import SoliticsBridge from './core';
import { SoliticsUser } from './../public/user';
import { SoliticsEvent } from './../public/event';
import { SoliticsPopupContent } from './../public/popupContent';
export class Solitics {
    constructor() {
        this.logListener = null;
        this.logListenerHandle = null;
        this.popupShouldOpenCallback = (_) => true;
        this.onPopupOpenedEventCallback = () => { };
        this.onPopupClosedEventCallback = () => { };
        this.onPopupClick_EventCallback = () => { };
        this.navigationShouldDismissPopupCallback = (_) => true;
        this.onNavigationDismissPopup = (_) => { };
        this.onPopupFailedToOpenCallback = (_) => { };
        this.logListener = null;
        this._registerPopupListeners();
    }
    async _registerPopupListeners() {
        try {
            this.logListenerHandle = await SoliticsBridge.addListener('onSoliticsLogMessageReceived', (payload) => { if (this.logListener) {
                this.logListener.logMessage(payload.message);
            } });
            await SoliticsBridge.addListener('popupShouldOpen', (payload) => {
                const popupContent = SoliticsPopupContent.fromObject(payload);
                const shouldOpen = this.popupShouldOpenCallback(popupContent);
                this._saveShouldOpenPopup(shouldOpen);
            });
            await SoliticsBridge.addListener('onPopupOpened', () => this.onPopupOpenedEventCallback());
            await SoliticsBridge.addListener('onPopupClosed', () => this.onPopupClosedEventCallback());
            await SoliticsBridge.addListener('onPopupClicked', () => this.onPopupClick_EventCallback());
            await SoliticsBridge.addListener('navigationShouldDismissPopup', (payload) => {
                const shouldDismiss = this.navigationShouldDismissPopupCallback(payload.url);
                this._saveShouldDismiss(shouldDismiss);
            });
            await SoliticsBridge.addListener('onNavigationDismissPopup', (payload) => {
                this.onNavigationDismissPopup(payload.url);
            });
            await SoliticsBridge.addListener('failedToOpenPopup', (payload) => {
                const popupContent = SoliticsPopupContent.fromObject(payload);
                this.onPopupFailedToOpenCallback(popupContent);
            });
        }
        catch (error) {
            console.error('Error registering listeners:', error);
        }
    }
    ;
    async _saveShouldOpenPopup(shouldOpen) {
        await SoliticsBridge.saveShouldOpenPopup({ state: shouldOpen });
    }
    async _saveShouldDismiss(shouldDismiss) {
        await SoliticsBridge.saveShouldDismiss({ state: shouldDismiss });
    }
    static get instance() {
        if (Solitics._instance === null) {
            Solitics._instance = new Solitics();
        }
        return Solitics._instance;
    }
    ;
    async getIsActiveNetworkLogs() {
        try {
            const response = await SoliticsBridge.getIsActiveNetworkLogs();
            return response.isActive;
        }
        catch (error) {
            console.error('Error fetching network logs state:', error);
            throw error;
        }
    }
    ;
    async setIsActiveNetworkLogs(isActive) {
        try {
            await SoliticsBridge.setIsActiveNetworkLogs({ state: isActive });
        }
        catch (error) {
            console.error('Error setting network logs status:', error);
        }
    }
    ;
    async onLogin(user) {
        try {
            return await SoliticsBridge.login({ user: user.toObject() });
        }
        catch (error) {
            console.error('Login failed:', error);
            throw error;
        }
    }
    ;
    async onLogout() {
        try {
            await SoliticsBridge.logout();
        }
        catch (error) {
            console.error('Logout failed:', error);
            throw error;
        }
    }
    ;
    async currentUser() {
        try {
            const result = await SoliticsBridge.currentUser();
            return new SoliticsUser(result);
        }
        catch (error) {
            console.error('Error fetching current user: ', error);
            throw error;
        }
    }
    ;
    async dismissPopup() {
        try {
            await SoliticsBridge.dismissPopup();
        }
        catch (error) {
            console.error('Error dismissing popup:', error);
            throw error;
        }
    }
    ;
    async emitEvent(event) {
        try {
            const result = await SoliticsBridge.emitEvent({ event: event.toObject() });
            return result;
        }
        catch (error) {
            console.error('Error emitting event:', error);
            throw error;
        }
    }
    ;
    async pageEnter(page) {
        return this.emitEvent(Solitics.createEvent('PAGE_ENTER', page));
    }
    ;
    async pageLeave(page) {
        return this.emitEvent(Solitics.createEvent('PAGE_LEAVE', page));
    }
    ;
    async processPushNotificationPayload(data) {
        try {
            const payload = JSON.stringify(data);
            await SoliticsBridge.processPushNotification({ payload: payload });
        }
        catch (error) {
            console.error('Logout failed:', error);
            throw error;
        }
    }
    ;
    async registerLogListener(listener) {
        try {
            if (this.logListenerHandle) {
                await this.removeSoliticsLogListener();
            }
            await SoliticsBridge.registerLogListener();
            this.logListener = listener;
            this.logListenerHandle = await SoliticsBridge.addListener('onSoliticsLogMessageReceived', (payload) => {
                if (this.logListener) {
                    this.logListener.logMessage(payload.message);
                }
            });
        }
        catch (error) {
            console.error('Error registering log listener:', error);
        }
    }
    ;
    async removeSoliticsLogListener() {
        try {
            if (this.logListenerHandle) {
                await SoliticsBridge.removeLogListener();
                await this.logListenerHandle.remove();
                this.logListenerHandle = null;
            }
        }
        catch (error) {
            console.error('Error removing log listener:', error);
        }
    }
    ;
    setSoliticsPopupDelegate(delegate) {
        if (delegate != null && delegate != undefined) {
            this.popupShouldOpenCallback = delegate.getOnPopupShouldOpenEventCallback();
            this.onPopupOpenedEventCallback = delegate.getOnPopupOpenedEventCallback();
            this.onPopupClosedEventCallback = delegate.getOnPopupClosedEventCallback();
            this.onPopupClick_EventCallback = delegate.getOnPopupClick_EventCallback();
            this.navigationShouldDismissPopupCallback = delegate.getOnShouldDismissForNavEventCallback();
            this.onNavigationDismissPopup = delegate.getOnPopupClosedForNavigation();
            this.onPopupFailedToOpenCallback = delegate.getOnPopupFailedToOpenCallback();
        }
        else {
            this.popupShouldOpenCallback = (_) => true;
            this.onPopupOpenedEventCallback = () => { };
            this.onPopupClosedEventCallback = () => { };
            this.onPopupClick_EventCallback = () => { };
            this.navigationShouldDismissPopupCallback = (_) => true;
            this.onNavigationDismissPopup = (_) => { };
            this.onPopupFailedToOpenCallback = (_) => { };
        }
    }
    ;
    static createEvent(action, page) {
        var fields = JSON.parse(page.customFields);
        if (!fields) {
            fields = {};
        }
        fields.page = page.name;
        return new SoliticsEvent({ name: action, amount: 0, fields: fields });
    }
}
Solitics._instance = null;
